import React from "react"
import { AppPageTabs } from "@components"
import { tabSelected } from "Pages/Admin/GlobalExecution/@signals"
import { GLOBAL_EXECUTION_TABS } from "Pages/Admin/GlobalExecution/@constants"


export default function AdminGlobalExecutionTabs() {


	// In the white band of the page, as the Alerts tabs
	return <AppPageTabs
			stackProps={{ sx: { mb: 0 } }}
			onChange={(_, value) => tabSelected.value = value}
			value={tabSelected.value}
			tabs={
				[{
					key: GLOBAL_EXECUTION_TABS.REGULAR,
					label: 'Regular Reports',
					value: GLOBAL_EXECUTION_TABS.REGULAR
				}, {
					key: GLOBAL_EXECUTION_TABS.EXTRAS,
					label: 'Reports Extra',
					value: GLOBAL_EXECUTION_TABS.EXTRAS
				}, {
					key: GLOBAL_EXECUTION_TABS.SCRAPERS,
					label: 'Batch Scraper Searches',
					value: GLOBAL_EXECUTION_TABS.SCRAPERS
				}, {
					key:GLOBAL_EXECUTION_TABS.BATCHES,
					label: 'Batch Executions',
					value: GLOBAL_EXECUTION_TABS.BATCHES
				}]
			}
		/>
}